import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Recommended PostHog configuration: https://posthog.com/tutorials/single-page-app-pageviews#tracking-pageviews-in-react-router
export const PostHogPageviewTracker = () => {
  const location = useLocation();
  const posthog = usePostHog();
  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
        app: 'portal',
      });
    }
  }, [location, posthog]);

  return null;
};
